var map = {
	"./accuracy.svg": "b147",
	"./audience.svg": "4d6e",
	"./brainstorm.svg": "3c19",
	"./export.svg": "e493",
	"./feedback.svg": "21b6",
	"./incorrect.svg": "2b773",
	"./openended.svg": "7407",
	"./other.svg": "aaab",
	"./poll.svg": "f043",
	"./qa.svg": "b52d",
	"./quiz.svg": "5245",
	"./rating.svg": "0d1c7",
	"./slide.svg": "fd50",
	"./submisstion.svg": "3a88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3fd";